import * as React from 'react'
import { connect } from 'react-redux'
import {Container, Row, Label, CardHeader, CardBody, Card, Col} from "reactstrap";
import {ApplicationState} from "src/store";
import {
    DocumentsInner,
    Product, SpecialOfferCompactListInner
} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {selectedLang} from "App/helper";
import {Language, linkToProduct, NATURAL_SORT_COMPARE_OPTIONS} from "App/constants";
import {ProductComponent} from "Components/ProductComponent";
import * as ReactMarkdown from "react-markdown";

interface StateToProps {
    soList: SpecialOfferCompactListInner | null | undefined
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    soList: state.data.specialoffers&&state.location?state.data.specialoffers.find(so => so.id===(state.location&&state.location.payload['sogId'])):null
});

class _Container extends React.PureComponent<StateToProps & WithTranslation> {
    render() {
        const {i18n, soList, t} = this.props;
        const language: Language = selectedLang(i18n);
        return soList?
            <Container className="py-5">
                <Row className="no-gutters">
                    <Col>
                        <Card>
                            <CardHeader className="px-4 d-flex align-items-center conf-title py-3">
                                <Label className="title-normal-uppercase m-0 ">{soList.nameml[language]}</Label>
                            </CardHeader>
                            <CardBody className="px-4 bodyslice pb-3">
                                <ReactMarkdown className="text-normal-details align-middle"
                                               source={(soList.descriptionml[language]||'').replace(/(?:\r|\n|\\n|\\r)/g, '<br>')}
                                               escapeHtml={false} />
                                {
                                    soList.documents?
                                        <div className="d-print-none text-normal-details">
                                            {
                                                soList.documents
                                                    .map((document: DocumentsInner, index: number) => {
                                                        return <button key={'key-998' + index} type="button"
                                                                       className="btn btn-light b3d"
                                                                       onClick={(e) => document.url && window.open(document.url, '_blank')}
                                                                       title={document.description && document.description[language]}>
                                                            <i className="far fa-file-download"></i>
                                                        </button>;
                                                    })
                                            }
                                        </div>:
                                        null
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className={"pt-3"}>
                    {
                        soList?
                            soList.products&&soList.products.length?
                                soList.products
                                    .sort((i1:Product, i2:Product) => (i1.nameml[language]||'').localeCompare(i2.nameml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                                    .map((product: Product,index) => <ProductComponent key={product.id} className={"py-3 col-sm-6 col-md-4 col-lg-3"} product={product} onClick={() => window.open(linkToProduct(product.id),"_self")}/>)
                                :<Label>{ t('products.configuration.noproducts') }</Label>
                            :null
                    }
                </Row>
            </Container>
            :null
    }
}

export const SpecialOfferPage = connect(mapStateToProps, null)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/SpecialOfferPage.tsx